import { useState } from "react";

import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { Button } from "@covertree/ui";
import UploadProofOfCoverageModal from "./UploadProofOfCoverageModal";
import { resetExternalCoverageData } from "@redux/coverages/coveragesSlice";
import useAppDispatch from "@redux/hooks/useAppDispatch";

interface UploadProofOfCoverageProps {
  residentId: string;
}

function UploadProofOfCoverage({ residentId }: UploadProofOfCoverageProps) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isDesktop = useMediaQuery(theme.breakpoints.up("xl"));

  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const toggleUploadModal = () => {
    dispatch(resetExternalCoverageData());
    setUploadModalOpen((prevValue) => !prevValue);
  };

  return (
    <>
      <Button
        size={isDesktop ? "large" : "medium"}
        onClick={toggleUploadModal}
        sx={{ minWidth: 182 }}>
        <Typography>Upload Proof of Coverage</Typography>
      </Button>
      <UploadProofOfCoverageModal
        open={uploadModalOpen}
        onClose={toggleUploadModal}
        residentId={residentId}
      />
    </>
  );
}

export default UploadProofOfCoverage;
